import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const PATHS = {
  NEW_STACK: "/stacks/new",
  NEW_STACK_EMBED: "/embed/stacks/new",
  STACK: "/stacks/:shareId",
  STACKS: "/stacks",
  STACKS_EMBED: "/embed/stacks",
  STACK_EMBED: "/embed/stacks/:shareId",
} as const;

const paths = {
  newStack: ({ embed }: { embed?: boolean }) => {
    return embed ? PATHS.NEW_STACK_EMBED : PATHS.NEW_STACK;
  },
  stacks: ({ embed }: { embed?: boolean }) => {
    return embed ? PATHS.STACKS_EMBED : PATHS.STACKS;
  },
  stack: ({ embed, shareId }: { embed?: boolean; shareId: string }) => {
    return embed
      ? PATHS.STACK_EMBED.replace(":shareId", shareId)
      : PATHS.STACK.replace(":shareId", shareId);
  },
};

export const useStackPaths = () => {
  const location = useLocation();

  const embed = location.pathname.startsWith("/embed");

  return useMemo(
    () => ({
      isEmbed: embed,
      stack: (params: { shareId: string }) => paths.stack({ ...params, embed }),
      stacks: () => paths.stacks({ embed }),
      newStack: () => paths.newStack({ embed }),
    }),
    [embed],
  );
};
